import {
  sectionLinks,
  sectionSegment,
  toolLinks,
} from "apollo/components/top-navigation/links";
import { TAB_SEGMENTS } from "./tab-bar-context";

/**
 * The title of a page reached from More (a tool, or a team page off the
 * tabs), or null for a tab, the builder and anything outside the tabs.
 * Below lg these pages are pushes inside the More stack.
 */
export const moreStackTitle = (pathname: string): string | null => {
  if (pathname.startsWith("/programs/[bootcampId]/")) {
    const page = pathname.split("/")[3];
    if (!page || TAB_SEGMENTS.includes(page) || page === "workout") return null;
    const section = sectionLinks.find(
      ({ href }) => sectionSegment(href) === page
    );
    return section?.name ?? null;
  }
  const tool = toolLinks.find(
    ({ href, external }) =>
      !external && (pathname === href || pathname.startsWith(`${href}/`))
  );
  return tool?.name ?? null;
};
